export const UserConstants = {
    UPLOAD_PROFILE_IMAGE_SUCCESS: 'UPLOAD_PROFILE_IMAGE_SUCCESS',
    UPLOAD_PROFILE_IMAGE_FAILURE: 'UPLOAD_PROFILE_IMAGE_FAILURE',

    GET_DETAILS_SUCCESS:"GET_DETAILS_SUCCESS",
    GET_DETAILS_FAILURE:"GET_DETAILS_FAILURE",

    PROFILE_DETAILS_SUCCESS:"PROFILE_DETAILS_SUCCESS",
    PROFILE_DETAILS_FAILURE:"PROFILE_DETAILS_FAILURE",

    SET_MANAGER_SUCCESS:"SET_MANAGER_SUCCESS",
    SET_MANAGER_FAILURE:"SET_MANAGER_FAILURE",

    CHANGE_MANAGER_SUCCESS: "CHANGE_MANAGER_SUCCESS",
    CHANGE_MANAGER_FAILURE: "CHANGE_MANAGER_FAILURE",

    CHANGE_TEAM_SUCCESS:"CHANGE_TEAM_SUCCESS",
    CHANGE_TEAM_FAILURE:"CHANGE_TEAM_FAILURE"
};